import React, { useEffect, useRef, useState } from "react";

import TableV2IconButton from "./TableV2IconButton";
import { Tray, TrayItems, TrayToggle } from "../styles";

const CLOSE_DELAY = 250;

const HeaderActionsTray = ({ icons }: { icons: React.ReactNode[] }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const toggleRef = useRef<HTMLDivElement>(null);
  const timer = useRef<number | undefined>(undefined);

  const cancelClose = () => window.clearTimeout(timer.current);

  const scheduleClose = () => {
    cancelClose();
    const check = () => {
      const tray = ref.current;
      if (!tray) return;
      const menuOpen = !!tray.querySelector('[data-state="open"]');
      const engaged =
        tray.matches(":hover") || tray.contains(document.activeElement);
      if (menuOpen) {
        timer.current = window.setTimeout(check, CLOSE_DELAY);
      } else if (!engaged) {
        setOpen(false);
      }
    };
    timer.current = window.setTimeout(check, CLOSE_DELAY);
  };

  const openTray = () => {
    cancelClose();
    setOpen(true);
  };

  useEffect(() => cancelClose, []);

  return (
    <Tray
      ref={ref}
      onMouseEnter={openTray}
      onMouseLeave={scheduleClose}
      onFocus={openTray}
      onBlur={scheduleClose}
      onKeyDown={(event) => {
        if (event.key !== "Escape") return;
        // Keep focus in the tray so it doesn't drop to the page
        toggleRef.current?.querySelector("button")?.focus();
        setOpen(false);
      }}
    >
      <TrayToggle ref={toggleRef} $open={open}>
        <TableV2IconButton
          tooltip={false}
          icon="fa-solid fa-table"
          label="Table actions"
          onClick={() => setOpen((value) => !value)}
        />
      </TrayToggle>
      <TrayItems $open={open} data-testid="table-actions-tray">
        {icons}
      </TrayItems>
    </Tray>
  );
};

export default HeaderActionsTray;
